/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Pub_DescInputs */

const en_fw_pub_desc = /** @type {(inputs: Fw_Pub_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share the shape of this plan — features, tasks and acceptance criteria. Your PRD body and your code are not shared.`)
};

const id_fw_pub_desc = /** @type {(inputs: Fw_Pub_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagikan bentuk rencana ini — fitur, task, dan kriteria penerimaan. Isi PRD dan kodemu tidak ikut dibagikan.`)
};

/**
* | output |
* | --- |
* | "Share the shape of this plan — features, tasks and acceptance criteria. Your PRD body and your code are not shared." |
*
* @param {Fw_Pub_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_pub_desc = /** @type {((inputs?: Fw_Pub_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Pub_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_pub_desc(inputs)
	return en_fw_pub_desc(inputs)
});